import { createStyles } from 'antd-style';

export const useSsoStyles = createStyles(({ css }) => ({
  layout: css`
    --sso-header-height: 112px;
    --sso-content-pt: 24px;
    min-height: 100vh;
    overflow: hidden;
    background: url('/assets/background.svg') center / cover no-repeat;
  `,
  header: css`
    position: relative;
    z-index: 2;
    height: var(--sso-header-height);
    padding-top: 32px;
    box-sizing: border-box;
  `,
  headerInner: css`
    position: relative;
    width: 100%;
    height: 56px;
  `,
  brand: css`
    position: absolute;
    left: 50%;
    top: 0;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    transform: translateX(-50%);
    text-decoration: none;
  `,
  logo: css`
    width: 50px;
    height: 50px;
    object-fit: contain;
  `,
  title: css`
    font-size: 22px;
    font-weight: 800;
    line-height: 1;
    white-space: nowrap;
    background: linear-gradient(180deg, #343468 0%, #1b1c3b 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  `,
  headerActions: css`
    position: absolute;
    top: 8px;
    right: 32px;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 760px) {
      right: 16px;
      gap: 4px;
    }
  `,
  languageSwitcher: css`
    flex: 0 0 auto;
  `,
  content: css`
    min-height: 100dvh;
    margin-top: calc(-1 * (var(--sso-header-height) + var(--sso-content-pt)));
    padding: calc(var(--sso-header-height) + var(--sso-content-pt)) 24px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 760px) {
      padding-left: 16px;
      padding-right: 16px;
    }
  `,
}));
